module.exports = __webpack_public_path__ + "static/media/slide1.b8901757.jpg";